import React from 'react';

export const AddIntegrationUsersDialogContainerStyle: React.CSSProperties = {
  minWidth: '480px'
};

export const SetIntegrationUserSiteRoleDialogContainerStyle: React.CSSProperties = {
  width: '400px'
};

export const DialogDescriptionStyle: React.CSSProperties = {
  marginBottom: '12px'
};

export const DialogSectionStyle: React.CSSProperties = {
  marginTop: '12px'
};

export const DialogFieldLabelStyle: React.CSSProperties = {
  marginBottom: '4px'
};

export const SiteRoleDropdownStyle: React.CSSProperties = {
  width: 352
};
